<template>
    <div class="thank-you-page">
        <div class="image-wrap">
            <img src="../assets/fb_logo_big.png"/>
        </div>
        <h1>Ups<span class="purple-text">!</span></h1>
        <h3>Podany link nie istnieje lub został już użyty.</h3>

        <div class="navigation">
            <a href="/" class="submit-purple-button">Powrót</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ConfirmationExpiredPage"
    }
</script>

<style scoped lang="scss">
    .thank-you-page {
        padding-left: 10px;
        padding-right: 10px;
        text-align: center;
        user-select: none;

        .navigation {
            margin-top: 40px;
            height: 50px;
        }

        img {
            margin-top: 130px;
            max-width: 180px;
        }

        h1 {
            margin-top: 2em;
            margin-bottom: 0;
        }

        h3 {
            font-size: 14px;
            margin-top: 2em;
            margin-bottom: 0.1em;
        }

        p {
            font-size: 14px;
            margin: 0;
        }
    }
</style>